
import { useState, useEffect } from 'react';

interface GlitchTextProps {
  text: string;
  className?: string;
  glitchIntensity?: 'low' | 'medium' | 'high';
}

export default function GlitchText({ text, className = '', glitchIntensity = 'medium' }: GlitchTextProps) {
  const [isGlitching, setIsGlitching] = useState(false);
  const [glitchText, setGlitchText] = useState(text);

  const glitchChars = '!@#$%^&*()_+-=[]{}|;:,.<>?~`';
  
  const createGlitch = () => {
    const chars = text.split('');
    const glitchedChars = chars.map((char, index) => {
      if (Math.random() < 0.3) {
        return glitchChars[Math.floor(Math.random() * glitchChars.length)];
      }
      return char;
    });
    return glitchedChars.join('');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() < 0.1) {
        setIsGlitching(true);
        setGlitchText(createGlitch());
        
        setTimeout(() => {
          setGlitchText(text);
          setIsGlitching(false);
        }, 100);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [text]);

  const glitchStyles = {
    low: 'animate-pulse',
    medium: isGlitching ? 'animate-bounce text-cyan-400' : '',
    high: isGlitching ? 'animate-ping text-red-500' : ''
  };

  return (
    <span className={`${className} ${glitchStyles[glitchIntensity]} transition-all duration-100`}>
      {glitchText}
    </span>
  );
}
